import { isEmpty } from "lodash-es";

const valueOf = (state, config) =>
  config?.field ? state?.[config.field] : state;

const VALIDATORS = {
  isRequired: (state, config) => {
    if (config?.field) return !isEmpty(state?.[config.field]);
    return Object.values(state ?? {}).some((v) => !isEmpty(v));
  },
  minLength: (state, config) =>
    (valueOf(state, config)?.toString().length ?? 0) >= (config?.value ?? 0),
  maxLength: (state, config) =>
    (valueOf(state, config)?.toString().length ?? 0) <=
    (config?.value ?? Infinity),
  regex: (state, config) => {
    const v = valueOf(state, config);
    return (
      typeof v === "string" &&
      new RegExp(config?.pattern, config?.flags).test(v)
    );
  },
  notEquals: (state, config) => {
    const v = valueOf(state, config);
    const bad = config?.value;
    if (Array.isArray(bad)) return !bad.includes(v);
    return v !== bad;
  },
};

export const isBodyValid = (body, state) =>
  (body?.validators ?? []).every((v) => {
    const fn = VALIDATORS[v?.type];
    return fn ? fn(state, v?.config) : true;
  });

export const collectErrors = (body, state) => {
  const errors = {};
  (body?.validators ?? []).forEach((v) => {
    const fn = VALIDATORS[v?.type];
    if (!fn) return;
    if (!fn(state, v?.config)) {
      const fieldId = v?.config?.field ?? "_body";
      const error = v?.config?.error;
      if (error && !errors[fieldId]) errors[fieldId] = error;
    }
  });
  return errors;
};
